export const categories = [
  {
    id: 'alla',
    name: 'Alla recept',
    icon: '🍽️',
    description: 'Utforska alla goda recept i samlingen'
  },
  {
    id: 'pannkakor',
    name: 'Pannkakor',
    icon: '🥞',
    description: 'Klassiska tunna pannkakor, plättar och ugnspannkaka'
  },
  {
    id: 'indiskt',
    name: 'Indiskt',
    icon: '🍛',
    description: 'Aromatiska grytor, kryddiga rätter och naanbröd'
  },
  {
    id: 'pasta',
    name: 'Pasta',
    icon: '🍝',
    description: 'Pastabaserade rätter'
  },
  {
    id: 'husmanskost',
    name: 'Husmanskost',
    icon: '🧆',
    description: 'Klassiska rätter'
  }
];
